import * as React from 'react';
import classnames from 'classnames';
import { CloseXSmall } from '@wix/wix-ui-icons-common/on-stage/system';
import { Text, TextTypography } from '../Text';
import { classes } from './Tag.st.css';
import { TagSize, TagSkin } from './types';
export const Tag = (props) => {
    const { skin, size, isRemovable, onClick, onRemove, removeButtonAriaLabel, children, className, tagName, } = props;
    const isClickable = !!(onRemove || onClick);
    const TagName = isClickable ? 'button' : tagName;
    return (React.createElement(TagName, { className: classnames(classes.root, classes[skin], classes[size], className, {
            [classes.clickable]: isClickable,
            [classes.withIcon]: isRemovable,
        }), onClick: isClickable ? handleClick : undefined, "data-hook": props['data-hook'] },
        React.createElement("div", { className: classes.opaque }),
        React.createElement(Text, { className: classes.label, typography: TextTypography.listText }, children),
        isRemovable && (React.createElement("span", { className: classes.iconWrapper, "aria-label": removeButtonAriaLabel, "data-hook": "remove-icon" },
            React.createElement(CloseXSmall, { className: classes.removeIcon })))));
    function handleClick(event) {
        if (isRemovable) {
            return onRemove(event);
        }
        return onClick ? onClick(event) : null;
    }
};
Tag.displayName = 'Tag';
Tag.defaultProps = {
    isRemovable: false,
    tagName: 'li',
    size: TagSize.medium,
    skin: TagSkin.solid,
};
//# sourceMappingURL=Tag.js.map